export default {
  getXsrfToken: state => state.xsrf_token
}
